import { render, staticRenderFns } from "./ReminderPage.vue?vue&type=template&id=b3957112&scoped=true&"
import script from "./ReminderPage.vue?vue&type=script&lang=ts&"
export * from "./ReminderPage.vue?vue&type=script&lang=ts&"
import style0 from "./ReminderPage.vue?vue&type=style&index=0&id=b3957112&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3957112",
  null
  
)

export default component.exports